import { getTreeId } from "routes/schedule/lib/getTreeId"
import { PlanRoot } from "library/tree/constants.mjs"

// Resolve the published-regime id for a bound tree item. Shared between the regime comments panel
// and the inline schedule comment indicator so the two views always agree on which regime a tree
// item belongs to. Returns `undefined` when the item is not under a resolvable regime.
export function getShareLinkCommentRegimeId({ itemId, rootItem }) {
    const rootId = rootItem?.id
    if (isPublishedRegimeId(rootId)) return rootId

    const treeId = getTreeId(itemId)
    const candidateId = treeId ?? rootId
    if (isPublishedRegimeId(candidateId)) return candidateId
    if (rootItem?.[PlanRoot] && isUnqualifiedRegimeId(candidateId)) return `live|${candidateId}`
    if (isPublishedRegimeId(itemId)) return itemId
    return undefined
}

// A published regime id carries a pipe (e.g. `live|regime-1`) and no schedule-qualifying bang.
export function isPublishedRegimeId(itemId = "") {
    return itemId.includes("|") && !itemId.includes("!")
}

// A bare regime id with no bang, no table-source colon, and not the `_root` sentinel.
export function isUnqualifiedRegimeId(itemId = "") {
    return !!itemId && !itemId.includes("!") && !itemId.includes(":") && itemId !== "_root"
}
